import {
  PRODUCT_SECTION_SPACING_WITH_DIVIDER,
  PRODUCT_SECTION_SPACING_WITHOUT_DIVIDER,
} from '@/feature/product/services/product.constants'
import { twMerge } from '@/lib/classname/twMerge'
import { Divider } from '@/ui/layouts/divider/Divider'
import type { ReactNode } from 'react'

type ProductDetailsInfosSectionProps = {
  children: ReactNode
  withDivider?: boolean
  className?: string
  id?: string
  'data-testid'?: string
}

/**
 * Wrapper component for product details sections
 * Provides consistent spacing and optional divider
 * Can be used in both server and client components
 */
export function ProductDetailsInfosSection({
  children,
  withDivider = true,
  className,
  id,
  'data-testid': dataTestId,
}: ProductDetailsInfosSectionProps) {
  return (
    <div
      className={twMerge(
        'flex flex-col',
        withDivider
          ? PRODUCT_SECTION_SPACING_WITH_DIVIDER
          : PRODUCT_SECTION_SPACING_WITHOUT_DIVIDER,
        className,
      )}
      id={id}
      data-testid={dataTestId}
    >
      {withDivider && <Divider direction="horizontal" variant="line" />}
      {children}
    </div>
  )
}
